$(document).ready(function() { 



  $('.press-text-columns-with-images-section .theme-button').attr('target', '_blank');
  

if ($(window).width() < 989) {
  
} else {
  $('#doubly_section').insertAfter('#doubly_section_desktop');
}


  

$('.footer-privacy-policy_link, .policy_privacy-policy').attr('target', '_blank');
 $('.policy_privacy-policy').attr('href', 'https://privacy.pfcandleco.com/privacy-policy'); 
  
$(".collection_tab_links .tab_a").click(function() {
  $('.collection_tab_slider').removeClass('active');
  var tablink = $(this).attr('data-src')
  $('#'+tablink).addClass('active');

  $('.tab_a').not(this).removeClass('active');
$(this).addClass('active');
  
}); 

// shop by scent page mobile
$(document).on('click','.scroll_row a', function(event) {
    event.preventDefault();
    var target = "#" + this.getAttribute('data-target');
    $('html, body').animate({
        scrollTop: $(target).offset().top - 70
    }, 1000);
});
  



$('.parent_div').focus(function(){  
   $('.dropdown_box').fadeOut();
   $(this).find('.bg-scheme-background').stop().fadeIn('fast');
   $(this).addClass('active');
   $(this).removeClass('noactive');
  $('.parent_div').not(this).addClass('noactive');
}, function(){
 //  $(this).find('.bg-scheme-background').stop().hide();
 //  $(this).removeClass('active');
 // $('.toplink').not(this).removeClass('noactive');
});

  $('.toplink > a').focus(function(){
     $('.parent_div').addClass('active');
   $('.parent_div').removeClass('noactive');
    $('.dropdown_box').fadeOut();    
});

$(".dropdown_box").mouseleave(function(){
   $('.parent_div').addClass('active');
   $('.parent_div').removeClass('noactive');
    $('.dropdown_box').fadeOut();    
});
$(".announcement-bar-section").hover(function(){
   $('.parent_div').addClass('active');
   $('.parent_div').removeClass('noactive');
    $('.dropdown_box').fadeOut();    
});
  
  

  $('.video_play').click(function () {
      var mediaVideo = $(this).next("video").get(0)
      if (mediaVideo.paused) {
          mediaVideo.play();

 $(this).toggleClass('stop');
        
      } else {
          mediaVideo.pause();
         $(this).removeClass('stop');
     }
   });
  
if ($(window).width() < 767) {
$("footer .font-heading.mb-4").click(function() {
  $('.footer_menu_list').not(this).stop().slideUp();  
  $(this).next('ul.footer_menu_list').stop().slideToggle();  

 
   $('footer .font-heading.mb-4').not(this).removeClass('active');
  $(this).toggleClass('active');
}); 

  

}
  
  });

// Body load opacity
$(window).on("load",(function(){ 
	//$("body").animate({opacity:1},700); 
  
    if ($(window).width() < 767) {
  
}
}));




//cookie code
/*
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}      
function _fnaccept() {
    setCookie('isvisited','yes',30);
    setCookie('isvisitedpopup','yes',30);
    $("#shopify-section-cookies").fadeOut(); 
}      
function getCookie(cname) {
var name = cname + "=";
var ca = document.cookie.split(';');
for(var i=0; i<ca.length; i++) {
   var c = ca[i];
   while (c.charAt(0)==' ') c = c.substring(1);
   if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
}
  return "";
}
 $(function(){
      var isvisited = getCookie("isvisited");
      var isvisitedpopup = getCookie("isvisitedpopup");      
      if (isvisited == null || isvisited=='')  {
        $(window).on('load', function() {
          $("#shopify-section-cookies").fadeIn();    
        });
      }   
      $(".cookie_accept").click(function() {
        setCookie('isvisited','yes', 30);
        $("#shopify-section-cookies").fadeOut();
      });
});
*/
//end cookie and newsletter


var $content = $('#shopify-section-cookies');

if (localStorage.getItem("isVisible") === null) {
	$content.addClass('content_visible');
} else {
	$content.removeClass('content_visible');
	localStorage.setItem('isVisible', $content.removeClass('content_visible'));
}

$('.cookie_accept').on('click', function() {
    $content.removeClass('content_visible');
    localStorage.setItem('isVisible', $content.hasClass('content_visible'));
});



